import request from 'local_modules/request'
import { constants } from 'helpers'
import { reducers, getState } from 'redux/core'


const setFetching = (isFetching) => reducers.marketplace.adminReportFoodPage.setFetching(isFetching)

const fetchStatisticSuccess = ({ fromInt, toInt }) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  return request.post(prefix.statSuccess, {
    fromInt,
    toInt,
  })
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminReportFoodPage.setStatisticSuccess(data))
    .catch((error) => console.log(error))
}

const fetchStatisticSuccessByDate = ({ fromInt, toInt }) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  return request.post(prefix.statSuccess + '/byDate', {
    fromInt,
    toInt,
  })
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminReportFoodPage.setStatisticSuccessByDate(data))
    .catch((error) => console.log(error))
}

const fetchStatisticAll = ({ fromInt, toInt }) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  return request.post(prefix.statAll, {
    fromInt,
    toInt,
  })
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminReportFoodPage.setStatisticAll(data))
    .catch((error) => console.log(error))
}

const fetchStatisticPositions = ({ fromInt, toInt }) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  return request.post(prefix.statPositions, {
    fromInt,
    toInt,
  })
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminReportFoodPage.setStatisticPositions(data))
    .catch((error) => console.log(error))
}

const fetchStatisticPositionsPayed = ({ fromInt, toInt }) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  return request.post(prefix.statPositionsPayed, {
    fromInt,
    toInt,
  })
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminReportFoodPage.setStatisticPositionsPayed(data))
    .catch((error) => console.log(error))
}

const fetchStatisticPositionsPayedTotal = ({ fromInt, toInt }) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  return request.post(prefix.statPositionsPayedTotal, {
    fromInt,
    toInt,
  })
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminReportFoodPage.setStatisticPositionsPayedTotal(data))
    .catch((error) => console.log(error))
}


export default {
  setFetching,

  fetchStatisticAll,
  fetchStatisticSuccess,
  fetchStatisticSuccessByDate,
  fetchStatisticPositions,
  fetchStatisticPositionsPayed,
  fetchStatisticPositionsPayedTotal
}
